/** @file The browser's frame clock for createPlaybackClock: performance.now and requestAnimationFrame. */
import type { ClockDeps } from './createPlaybackClock';

/** Read lazily per call, so importing this file needs no DOM. */
export const browserClock: ClockDeps = {
  now: () => performance.now(),
  requestFrame: (cb) => requestAnimationFrame(cb),
  cancelFrame: (handle) => { cancelAnimationFrame(handle); },
};
